export default __webpack_public_path__ + "static/like_light-b7ac22841e29e0e2651c7f3c1e62b3aa.svg";